// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1jRTB","errorLogs":"styles_errorLogs__2WdO1"};